<template>
  <section v-if="getShowCommercialIIICampaign" class="wrapper-campaign">
    <header>
      <h1>Campanha Comercial III</h1>
    </header>

    <div class="scheduled-clients-button">
      <button class="btn scheduled-btn" @click="showScheduledClients">
        <i class="fa-solid fa-calendar-day"></i> Agenda
      </button>
    </div>

    <div v-if="validateClients">
      <div class="client-card" :class="{ 'card-redial': showCurrentClient.redial, 'card-tabulated': !showCurrentClient.redial && showCurrentClient.tab }">

      <!-- Cabeçalho do cliente -->
      <div class="client-card-header">
        <div class="client-identity">
          <div class="client-avatar"><i class="fas fa-building"></i></div>
          <div>
            <h2 class="client-name">{{ showCurrentClient.nome_cliente }}</h2>
            <span class="client-razao" v-if="showCurrentClient.razao_social">{{ showCurrentClient.razao_social }}</span>
          </div>
        </div>
        <div class="header-badges">
          <span v-if="showCurrentClient.situacao_empresa"
            :class="['status-badge', showCurrentClient.situacao_empresa === 'Ativa' ? 'badge-ativa' : 'badge-inativa']">
            <i class="fas fa-circle dot-icon"></i>{{ showCurrentClient.situacao_empresa }}
          </span>
          <span v-if="showCurrentClient.tab" class="tab-badge">
            {{ convertTabOption(showCurrentClient.tab) }}
          </span>
        </div>
      </div>

      <!-- Grid de informações -->
      <div class="info-grid">

        <!-- Informações Principais -->
        <div class="info-section">
          <h3 class="section-title"><i class="fas fa-info-circle"></i> Informações Principais</h3>
          <div class="field-list">
            <div class="field-item" v-if="showCurrentClient.projeto">
              <span class="field-label">Projeto</span>
              <span class="field-value">{{ showCurrentClient.projeto }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.produto">
              <span class="field-label">Produto</span>
              <span class="field-value">{{ showCurrentClient.produto }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.cnpj">
              <span class="field-label">CNPJ</span>
              <span class="field-value">{{ showCurrentClient.cnpj }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.nome_fantasia">
              <span class="field-label">Nome Fantasia</span>
              <span class="field-value">{{ showCurrentClient.nome_fantasia }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.segmento_empresa">
              <span class="field-label">Segmento</span>
              <span class="field-value">{{ showCurrentClient.segmento_empresa }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.porte_empresa">
              <span class="field-label">Porte</span>
              <span class="field-value">{{ showCurrentClient.porte_empresa }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.canal_origem">
              <span class="field-label">Canal de Origem</span>
              <span class="field-value">{{ showCurrentClient.canal_origem }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.email">
              <span class="field-label"><i class="fas fa-envelope"></i> Email</span>
              <span class="field-value">{{ showCurrentClient.email }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.telefone">
              <span class="field-label"><i class="fas fa-phone"></i> Telefone</span>
              <span class="field-value">{{ showCurrentClient.telefone }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.endereco_empresa">
              <span class="field-label"><i class="fas fa-map-marker-alt"></i> Endereço</span>
              <span class="field-value">{{ showCurrentClient.endereco_empresa }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.link">
              <span class="field-label"><i class="fas fa-link"></i> Link</span>
              <a class="field-value link-value" :href="showCurrentClient.link" target="_blank" rel="noopener noreferrer">{{ showCurrentClient.link }}</a>
            </div>
          </div>
        </div>

        <!-- Informações Complementares -->
        <div class="info-section">
          <h3 class="section-title"><i class="fas fa-chart-bar"></i> Informações Complementares</h3>
          <div class="field-list">
            <div class="field-item" v-if="showCurrentClient.faturamento_empresa">
              <span class="field-label">Faturamento</span>
              <span class="field-value value-highlight">{{ formatMoney(showCurrentClient.faturamento_empresa) }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.media_colaboradores">
              <span class="field-label">Média Colaboradores</span>
              <span class="field-value">{{ showCurrentClient.media_colaboradores }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.score_investimento">
              <span class="field-label">Score de Investimento</span>
              <span class="field-value score-value">{{ showCurrentClient.score_investimento }}<small> / 100</small></span>
            </div>
            <div class="field-item" v-if="showCurrentClient.nota_google">
              <span class="field-label">Nota no Google</span>
              <span class="field-value">{{ showCurrentClient.nota_google }}<small> / 5</small> <i class="fas fa-star star-icon"></i></span>
            </div>
            <div class="field-item" v-if="showCurrentClient.dominio">
              <span class="field-label">Domínio</span>
              <span class="field-value">{{ showCurrentClient.dominio }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.tempo_dominio">
              <span class="field-label">Tempo de Domínio</span>
              <span class="field-value">{{ showCurrentClient.tempo_dominio }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.data_abertura_empresa">
              <span class="field-label">Data de Abertura</span>
              <span class="field-value">{{ showCurrentClient.data_abertura_empresa }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.redes_sociais_ativas">
              <span class="field-label">Redes Sociais Ativas</span>
              <span class="field-value">{{ showCurrentClient.redes_sociais_ativas }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.anuncios_ativos">
              <span class="field-label">Anúncios Ativos</span>
              <span class="field-value">{{ showCurrentClient.anuncios_ativos }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.info_lead">
              <span class="field-label">Info Lead</span>
              <span class="field-value">{{ showCurrentClient.info_lead }}</span>
            </div>
            <div class="field-item" v-if="showCurrentClient.principais_produtos_servicos">
              <span class="field-label">Principais Produtos/Serviços</span>
              <span class="field-value">{{ showCurrentClient.principais_produtos_servicos }}</span>
            </div>
          </div>
        </div>
      </div>

      </div>

      <!-- Observação de tabulação -->
      <div class="tab-obs-box" v-if="showCurrentClient.tab_obs">
        <i class="fas fa-comment-alt"></i> {{ showCurrentClient.tab_obs }}
      </div>

      <!-- Botão de discagem + timer -->
      <div class="dial-footer">
        <button class="dial-btn" :class="{ 'dial-btn-active': isDialEnabled, 'dial-btn-disabled': !isDialEnabled }"
          @click="dialCurrentClient" :disabled="!isDialEnabled">
          <i class="fas fa-phone"></i> Discar para {{ showCurrentClient.nome_cliente }}
        </button>
        <div class="clock-wrap">
          <div class="clock pro-0">
            <span class="count">{{ count }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="wrapper-no-clients">
      <i class="fas fa-ban"></i>
      <p>Sem Clientes</p>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

// Campanha de ligação: depende apenas da telefonia (AMI), nunca do Whatsapp.
const parsedTelefone = process.env.MIX_TELEFONE === "true";
const isSSL = location.hostname == "localhost" ? "http" : "https";
const socketAMI = parsedTelefone
  ? io.connect(`${isSSL}://${location.hostname}:3002/`)
  : { on: function () {}, emit: function () {} };

// Prefixo de saída do plano de discagem. Vazio porque a telefonia da Faculdade
// Ideal disca o número puro (mesma convenção do ModalDiscar).
const OUTBOUND_PREFIX = "";

const SESSION_KEY = "campaignClientComercialIII";

export default {
  name: "CommercialIIIDialCampaign",
  data() {
    return {
      campaignClients: [],
      tabOptions: [],
      // IDs de at_option_status que disparam rediscagem / agendamento. Resolvidos
      // pelo backend porque variam por instalação.
      redialTabs: [],
      scheduleTabs: [],
      interval: null,
      clientCheckInterval: null,
      count: 0,
      inCall: false,
      isDialEnabled: false,
      isUpdatingCampaign: false,
      clients: [],
    };
  },
  methods: {
    ...mapActions(["setCallData"]),

    dialCurrentClient() {
      if (this.inCall || !this.isDialEnabled) return;
      if (this.validateClients) {
        this.clearCountdown();
        this.isDialEnabled = false;
        const clientPhone = this.formatPhoneToCall(this.campaignClients[0].telefone);
        socketAMI.emit("Originate", {
          calltype: "outgoing",
          extension: user.getExtension(),
          phone: `${OUTBOUND_PREFIX}${clientPhone}`,
        });
      }
    },

    async showScheduledClients() {
      await this.checkClients();
      const check = this.clients;
      let notifiedSwal = false;

      if (check) check.sort((a, b) => moment(a.schedule_date).unix() - moment(b.schedule_date).unix());

      if (check.length) {
        const upcomingSchedules = check.filter(client => {
          const diffInMinutes = moment(client.schedule_date).diff(moment(), "minutes");
          return diffInMinutes <= 60 && diffInMinutes >= 0;
        }).map(client => ({
          clientName: client.nome_cliente,
          time: moment(client.schedule_date).format("HH:mm"),
        }));

        if (upcomingSchedules.length > 0 && !notifiedSwal) {
          let scheduleListHTML = '<ul style="list-style-type: none; padding: 0; margin: 0;">';
          upcomingSchedules.forEach(schedule => {
            scheduleListHTML += `<li style="padding: 8px 15px; font-size: 14px; display: flex; justify-content: space-between; align-items: center; background-color: #ffffff; border-radius: 5px; margin-bottom: 5px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <strong style="color: #1a6fa5;">${schedule.clientName}</strong>
              <span style="color: #16a085; font-weight: bold;">${schedule.time}</span>
            </li>`;
          });
          scheduleListHTML += "</ul>";

          Swal.fire({
            toast: true,
            position: "top-end",
            html: `<div style="font-family: Arial, sans-serif; max-width: 300px; text-align: center;">
              <div style="display: flex; justify-content: center; align-items: center; background-color: #16a085; border-radius: 50%; width: 50px; height: 50px; margin: 0 auto; color: #fff;">
                <i class="fas fa-calendar-check" style="font-size: 24px;"></i>
              </div>
              <h3 style="color: #2c3e50; margin: 20px 0 10px 0; font-size: 18px; font-weight: bold;">Clientes Agendados!</h3>
              <div style="max-height: 200px; overflow-y: auto;">${scheduleListHTML}</div>
              <p style="color: #555; font-size: 14px; margin-top: 15px;">
                Existem <strong style="color: #e74c3c;">${upcomingSchedules.length}</strong> clientes agendados em até 1 hora.
              </p>
            </div>`,
            showCloseButton: true,
            showConfirmButton: false,
            background: "#ecf0f1",
          });
          notifiedSwal = true;
        }
      } else if (!notifiedSwal) {
        Swal.fire({
          toast: true,
          position: "top-end",
          html: `<div style="font-family: Arial, sans-serif; max-width: 300px; text-align: center;">
            <div style="display: flex; justify-content: center; align-items: center; background-color: #e74c3c; border-radius: 50%; width: 50px; height: 50px; margin: 0 auto; color: #fff;">
              <i class="fas fa-calendar-xmark" style="font-size: 24px;"></i>
            </div>
            <h3 style="color: #2c3e50; margin: 20px 0 10px 0; font-size: 18px; font-weight: bold;">Sem Clientes Agendados</h3>
            <p style="color: #555; font-size: 14px; margin-bottom: 20px;">Sem clientes agendados em até 1 hora.</p>
          </div>`,
          showCloseButton: true,
          showConfirmButton: false,
          background: "#ecf0f1",
        });
      }
    },

    async startFromHangup() {
      this.inCall = false;
      if (!this.validateClients) return;
      await this.updateClient(this.campaignClients[0], this.getCallData);
      this.setCallData({ call_id: null, tab: null, tab_obs: null, scheduling_datetime: null });
      this.getClients();
      this.startCountdown();
    },

    async delaySendingCall(ms = 1000) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async deactivateCampaignAndSetDefault() {
      const response = await axios.post("/desactivateComercialIIICampaign");
      if (response.data && response.data.success) {
        const deactivatedCampaign = response.data.deactivated_campaign;
        await Swal.fire({
          html: `<div style="text-align: center; font-family: Arial, sans-serif; color: #333;">
            <p style="font-size: 1.5em; font-weight: bold; color: #D32F2F; margin: 15px 0;">
              <span style="font-style: italic;">${deactivatedCampaign}</span>
            </p>
            <p style="font-size: 1.05em; margin: 5px 0; line-height: 1.3;">
              A campanha foi desativada por exceder os 30 dias limites de ativação.
            </p>
          </div>`,
          showConfirmButton: true,
          confirmButtonText: '<i class="fa-regular fa-circle-check"></i>',
          confirmButtonColor: "#4CAF50",
          allowOutsideClick: false,
        });
        sessionStorage.removeItem(SESSION_KEY);
      }
    },

    async getClients() {
      if (this.isUpdatingCampaign) return;
      this.isUpdatingCampaign = true;
      try {
        await this.deactivateCampaignAndSetDefault();
        const clientSession = sessionStorage.getItem(SESSION_KEY);
        if (clientSession && clientSession !== "undefined") {
          this.campaignClients = [JSON.parse(clientSession)];
          return;
        }

        const currentTime = moment().format("HH:mm");

        const { data: scheduledClients } = await axios.get("/generateComercialIIICampaignScheduleds");
        const clientsScheduledForNow = scheduledClients.filter(client => {
          return moment(client.schedule_date).format("HH:mm") <= currentTime;
        });

        if (clientsScheduledForNow.length > 0) {
          this.campaignClients = clientsScheduledForNow;
          sessionStorage.setItem(SESSION_KEY, JSON.stringify(clientsScheduledForNow[0]));
          return;
        }

        const { data: defaultClients } = await axios.get("/generateComercialIIICampaign");
        await this.delaySendingCall(1000);

        const orderedClients = defaultClients
          .filter(c => c.telefone && c.telefone.trim() !== "")
          .sort((a, b) => a.redial_count - b.redial_count);

        this.campaignClients = orderedClients;
        if (this.campaignClients.length > 0) {
          sessionStorage.setItem(SESSION_KEY, JSON.stringify(this.campaignClients[0]));
        }
      } catch (error) {
        console.error("Erro ao obter clientes Comercial III:", error);
      } finally {
        this.isUpdatingCampaign = false;
      }
    },

    startClientCheckInterval() {
      this.clientCheckInterval = setInterval(() => {
        if (!this.getShowCommercialIIICampaign) return;
        if (!sessionStorage.getItem(SESSION_KEY)) {
          this.getClients();
          this.startCountdown();
        }
      }, 10000);
    },

    stopClientCheckInterval() {
      if (this.clientCheckInterval) clearInterval(this.clientCheckInterval);
    },

    getTabOptions() {
      axios.get("/listTabOptionsCommercial").then(({ data }) => {
        this.tabOptions = data;
      });
    },

    getTabBehavior() {
      return axios.get("/campaignTabBehaviorCommercial").then(({ data }) => {
        this.redialTabs = data.redial || [];
        this.scheduleTabs = data.schedule || [];
      }).catch(() => {
        this.redialTabs = [];
        this.scheduleTabs = [];
      });
    },

    isRedialTab(tab) {
      return this.redialTabs.includes(Number(tab));
    },

    isScheduleTab(tab) {
      return this.scheduleTabs.includes(Number(tab));
    },

    async checkClients() {
      const { data } = await axios.get("/getScheduledCallsComercialIII");
      this.clients = Array.isArray(data) ? data : [];
    },

    async updateClient(client, callData) {
      client.call_id = callData.call_id || null;
      client.tab = callData.tab || null;
      client.tab_obs = callData.tab_obs || null;
      client.schedule_date = callData.scheduling_datetime || null;

      if (this.isScheduleTab(callData.tab)) {
        if (!client.tab_obs)
          client.tab_obs = "Agendamento: " + moment(callData.scheduling_datetime).format("DD/MM/YYYY HH:mm:ss");
        client.schedule_check = 1;
      } else {
        client.schedule_date = null;
        callData.scheduling_datetime = null;
        client.schedule_check = 1;
      }

      if (this.isRedialTab(callData.tab)) {
        // Coerção numérica: a API pode devolver redial/redial_count como string
        if (Number(client.redial)) {
          client.redial_count = (Number(client.redial_count) || 0) + 1;
        } else {
          client.redial = true;
          client.redial_count = 1;
        }

        const redial_date = moment().startOf("day").format("YYYY-MM-DD");
        if (client.redial_count >= 3) {
          client.tab_obs = "Limite de rediscagem atingido, não foi possivel contactar o cliente!";
          client.redial = false;
          client.last_redial_date = redial_date;
        }
      } else {
        client.redial = false;
      }

      return await axios.put("/updateComercialIIICampaign", client).then(() => {
        sessionStorage.removeItem(SESSION_KEY);
        this.setCallData({ call_id: null, tab: null, tab_obs: null, scheduling_datetime: null });
      });
    },

    listeningCalls() {
      socketAMI.on(`CoreShowChannel-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });
      socketAMI.on(`NewConnectedLine-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });
    },

    listeningHangupRinging() {
      socketAMI.on(`HangupRinging-${user.getExtension()}`, () => {
        this.inCall = false;
      });
    },

    async maxRedialClients() {
      const { data } = await axios.get("/maxRedialAttemptComercialIII");
      const today = moment().startOf("day").unix();
      data.forEach(client => {
        const lastRedialDate = moment(client.last_redial_date).startOf("day").unix();
        if (today > lastRedialDate) {
          axios.post("/saveRedialHistoryComercialIII", {
            client_id: client.id,
            redial_date: client.last_redial_date,
            redial_count: client.redial_count,
          }).then(() => {
            return axios.put("/resetRedialAttemptComercialIII", { id: client.id, redial: 1, redial_count: 0 });
          }).catch(error => console.error(`Erro ao processar cliente ${client.id}:`, error));
        }
      });
    },

    formatPhoneToCall(phone) {
      let newPhone = phone.replace(/\D/g, "");
      newPhone = newPhone.slice(0, 2) == "55" ? newPhone.slice(2) : newPhone;
      return newPhone;
    },

    formatMoney(value) {
      if (value === null || value === undefined) return "";
      const numericValue = value.toString().replace(/[^\d.,]/g, "");
      const cleanedValue = numericValue.replace(",", ".");
      const floatValue = parseFloat(cleanedValue);
      if (isNaN(floatValue)) return "";
      return floatValue.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },

    convertTabOption(option) {
      return this.tabOptions[option] || "";
    },

    async startCountdown() {
      this.clearCountdown();
      let sec = 10;
      this.count = sec;
      this.isDialEnabled = false;
      $(".count").addClass("sec");

      this.interval = setInterval(() => {
        sec = sec - 1;

        if (sec == 0) {
          this.stopCountdown();
        } else {
          this.count = sec;
        }
      }, 1000);

      setTimeout(() => {
        this.isDialEnabled = true;
      }, 2000);
    },

    stopCountdown() {
      this.clearCountdown();
      this.dialCurrentClient();
    },

    clearCountdown() {
      clearInterval(this.interval);
      this.count = 0;
      $(".clock").removeAttr("style");
    },
  },

  async beforeMount() {
    // As tabulações precisam estar carregadas antes da primeira gravação.
    await this.getTabBehavior();
    this.getClients();
    this.getTabOptions();
    this.listeningHangupRinging();
    this.listeningCalls();
  },

  mounted() {
    if (this.getShowCommercialIIICampaign && !this.inCall) {
      this.startCountdown();
    }
    this.startClientCheckInterval();
    this.maxRedialClients();
  },

  beforeDestroy() {
    this.clearCountdown();
    this.stopClientCheckInterval();
  },

  computed: {
    ...mapGetters([
      "getShowCommercialIIICampaign",
      "getStartCampaign",
      "getCallData",
    ]),
    validateClients() {
      return this.campaignClients.length > 0;
    },
    showCurrentClient() {
      return this.campaignClients[0] || false;
    },
  },

  watch: {
    getStartCampaign() {
      this.startFromHangup();
    },
    getShowCommercialIIICampaign() {
      if (this.getShowCommercialIIICampaign && !this.inCall) {
        this.startCountdown();
      }
    },
  },
};
</script>

<style scoped>
/* ── Wrapper ── */
.wrapper-campaign { padding: 10px; border: 1px solid #c2c2c2; border-radius: 10px; margin: 20px; box-shadow: 0 0 15px rgba(0,0,0,0.15); position: relative; }
.wrapper-campaign header { height: 100px; margin-bottom: 20px; border-radius: 10px 10px 0 0; background: linear-gradient(180deg, rgba(28,134,154,1) 0%, rgba(255,255,255,1) 100%); display: flex; align-items: center; justify-content: center; }
.wrapper-campaign header h1 { font-size: 2.4rem; color: #fff; margin: 0; text-shadow: 0 1px 3px rgba(0,0,0,0.2); }

/* ── Agenda button ── */
.scheduled-clients-button { position: absolute; right: 0; top: 0; margin: 45px; }
.scheduled-btn { background-color: #007bff; color: white; border-radius: 20px; padding: 8px 22px; font-weight: bold; font-size: 13px; box-shadow: 0 2px 5px rgba(0,0,0,0.15); border: none; transition: background-color 0.3s, transform 0.2s; cursor: pointer; }
.scheduled-btn:hover { background-color: #0056b3; transform: scale(1.05); }

/* ── Client Card ── */
.client-card { background: #fff; border-radius: 12px 12px 0 0; border: 1px solid #e0e0e0; margin: 0 10px 0; box-shadow: 0 2px 8px rgba(0,0,0,0.07); overflow-y: auto; max-height: calc(100vh - 280px); }
.card-redial { border-left: 4px solid #f4a623; }
.card-tabulated { border-left: 4px solid #28a745; }

/* ── Card Header ── */
.client-card-header { display: flex; justify-content: space-between; align-items: flex-start; padding: 16px 20px; background: #f8f9fa; border-bottom: 1px solid #eee; }
.client-identity { display: flex; align-items: center; gap: 12px; }
.client-avatar { width: 48px; height: 48px; border-radius: 50%; background: linear-gradient(135deg, #1c869a, #00b4d8); display: flex; align-items: center; justify-content: center; color: #fff; font-size: 20px; flex-shrink: 0; }
.client-name { margin: 0; font-size: 1.25rem; font-weight: 700; color: #1a1a2e; }
.client-razao { font-size: 0.82rem; color: #666; }
.header-badges { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
.status-badge { display: inline-flex; align-items: center; gap: 5px; padding: 4px 10px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; }
.badge-ativa { background: #d4edda; color: #155724; }
.badge-inativa { background: #f8d7da; color: #721c24; }
.dot-icon { font-size: 7px; }
.tab-badge { background: #e3f2fd; color: #0d47a1; padding: 4px 10px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; }

/* ── Info Grid ── */
.info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0; }
.info-section { padding: 16px 20px; }
.info-section:first-child { border-right: 1px solid #eee; }
.section-title { font-size: 0.82rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #1c869a; margin: 0 0 12px; display: flex; align-items: center; gap: 6px; }

/* ── Field List ── */
.field-list { display: flex; flex-direction: column; gap: 8px; }
.field-item { display: flex; flex-direction: column; }
.field-label { font-size: 0.72rem; font-weight: 600; color: #888; text-transform: uppercase; letter-spacing: 0.3px; }
.field-value { font-size: 0.92rem; color: #222; margin-top: 1px; }
.value-highlight { color: #155724; font-weight: 700; }
.score-value { font-size: 1.1rem; font-weight: 700; color: #1c869a; }
.star-icon { color: #f4a623; font-size: 0.8rem; }
.link-value { color: #1c869a; text-decoration: underline; font-size: 0.88rem; word-break: break-all; }

/* ── Tab obs ── */
.tab-obs-box { margin: 0 20px 12px; padding: 10px 14px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 8px; font-size: 0.88rem; color: #856404; display: flex; align-items: flex-start; gap: 8px; }

/* ── Dial Footer ── */
.dial-footer { display: flex; align-items: center; justify-content: space-between; padding: 12px 20px; border-top: 2px solid #1c869a; background: #f8f9fa; gap: 16px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); margin: 0 10px 10px; border-radius: 0 0 12px 12px; }
.dial-btn { display: inline-flex; align-items: center; gap: 8px; padding: 10px 24px; border-radius: 24px; border: none; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: all 0.2s; }
.dial-btn-active { background: linear-gradient(135deg, #1c869a, #00b4d8); color: #fff; box-shadow: 0 4px 12px rgba(28,134,154,0.35); }
.dial-btn-active:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(28,134,154,0.45); }
.dial-btn-disabled { background: #e0e0e0; color: #999; cursor: not-allowed; }

/* ── No clients ── */
.wrapper-no-clients { display: flex; flex-direction: column; align-items: center; padding: 40px; color: #ccc; }
.wrapper-no-clients i { font-size: 50px; color: #e74c3c; }
.wrapper-no-clients p { margin-top: 10px; font-size: 1.2rem; color: #666; }

/* ── Clock ── */
.clock-wrap { width: 90px; height: 90px; position: relative; border-radius: 50%; background-color: #fff; box-shadow: 0 0 10px rgba(0,0,0,0.12); flex-shrink: 0; }
.clock { top: 50%; left: 50%; width: 72px; height: 72px; border-radius: 50%; position: absolute; margin-top: -36px; margin-left: -36px; background-color: #feeff4; }
.clock:before { content: ""; position: absolute; top: 50%; left: 50%; width: 48px; height: 48px; margin-top: -24px; margin-left: -24px; border-radius: inherit; background-color: #00b4d8; box-shadow: 0 0 10px rgba(0,0,0,0.15); }
.count { width: 100%; color: #fff; height: 100%; padding: 20px 0; font-size: 18px; font-weight: 600; position: absolute; text-align: center; line-height: 32px; }
.count:after { content: ""; width: 100%; display: block; font-size: 11px; font-weight: 300; text-align: center; }
.count.sec:after { content: "sec"; }
.count.min:after { content: "min"; }
</style>
